import { render, staticRenderFns } from "./InvestmentPlansPage.vue?vue&type=template&id=37454e3c&scoped=true"
import script from "./InvestmentPlansPage.vue?vue&type=script&lang=js"
export * from "./InvestmentPlansPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37454e3c",
  null
  
)

export default component.exports